var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"ProductList height2"},[_c('ProductList',{attrs:{"typeName":_vm.typeName}})],1),_c('FootTab')],1)}
var staticRenderFns = []

export { render, staticRenderFns }